<template>
  <v-card height="100%">
    <v-card-title class="px-6">
      Accepted Invitation
      <v-spacer></v-spacer>
      <dashboard-accepted-invitation-dialog
        :users="filtered_users"
      ></dashboard-accepted-invitation-dialog>
    </v-card-title>
    <v-card-text class="px-8">
      <v-row class="background rounded-lg">
        <v-col cols="auto" class="text-h3 accent--text">
          {{ total }}
        </v-col>
        <v-col class="my-auto">
          # of employees activated in CoreCounts
        </v-col>
      </v-row>
      <v-row class="subtitle-1" v-for="(user, i) in users_to_show" :key="i">
        <v-col cols="auto">
          <user-avatar :user="user"></user-avatar>
        </v-col>
        <v-col>
          {{ user.fullName }}
        </v-col>
      </v-row>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions class="px-6">
      <copy-text-field
        title="Invitation Link"
        :link="settings.registrationLink"
      ></copy-text-field>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import DashboardAcceptedInvitationDialog from "@/components/dashboard/DashboardAcceptedInvitationDialog";
import CopyTextField from "@/components/common/CopyTextField";
export default {
  name: "DashboardAcceptedInvitationCard",
  components: { DashboardAcceptedInvitationDialog, CopyTextField },
  data: () => ({
    loading: false,
    saving: false
  }),
  computed: {
    users_to_show() {
      return this._.take(this.filtered_users, 5);
    },
    total() {
      return this.filtered_users.length;
    },
    filtered_users() {
      return this.users.filter(x => x.id != this.profile.id);
    },
    ...mapGetters({
      users: "user/users",
      settings: "profile/settings",
      profile: "profile/profile"
    })
  },
  methods: {}
};
</script>
